import { deserialize } from 'libs/cerialize';

export class SubflowMonitorRecordModel {
	@deserialize
	RecordId: number;

	@deserialize
	Name: string;

	@deserialize
	LifeStatusName: string;
}

export class SubflowMonitorModel {
	@deserialize
	EntityId: number;

	@deserialize
	EntityName: string;

	@deserialize
	CompletionLifeStatusId: number;

	@deserialize
	CompletionLifeStatusName: string;

	@deserialize
	TypeId: number;

	@deserialize
	TypeName: string;

	@deserialize
	HasLinkedRecords: boolean;

	@deserialize
	UnfinishedCount: number;

	IsBlocking(): boolean {
		return this.HasLinkedRecords && (this.UnfinishedCount || 0) > 0;
	}
}
